<template>
  <div id="financeTop">
    <div class="title">
      <img src="../../assets/image/icon_caiw@2x.png" style="width:34px" alt />
      <h3>财务</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="clientActive" @tab-click="handleClick">
        <!-- 1总览 -->
        <el-tab-pane label="总览" name="1">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left">
              <el-date-picker
                class="fffBorder"
                v-model="searchDate1"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                class="fffBorder"
                v-model="searchDate2"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
            </div>
            <div class="right">
              <el-button class="search" @click="handleSearchIndex">查询</el-button>
            </div>
          </div>
          <ul class="totalNum">
            <li>
              <span style="color:#FF1A1A" class="title">总到账金额</span>
              <span style="color:#FF1A1A" class="number">{{financeIndexData.arrival_all}}</span>
            </li>
            <li>
              <span style="color:#079AEE" class="title">总支出金额</span>
              <span style="color:#079AEE" class="number">{{financeIndexData.expend_all}}</span>
            </li>
            <li>
              <span style="color:#009900" class="title">今日到账金额</span>
              <span style="color:#009900" class="number">{{financeIndexData.arrival_today}}</span>
            </li>
            <li>
              <span style="color:#FF9900" class="title">报销金额（总）</span>
              <span style="color:#FF9900" class="number">{{financeIndexData.reimbursement_all}}</span>
            </li>
            <li>
              <span style="color:#EA4A9D" class="title">项目结算（总）</span>
              <span style="color:#EA4A9D" class="number">{{financeIndexData.settlement_all}}</span>
            </li>
            <li>
              <span style="color:#16BEA4" class="title">项目专家（总）</span>
              <span style="color:#16BEA4" class="number">{{financeIndexData.expert_all}}</span>
            </li>
          </ul>
          <div class="echartsRow">
            <div ref="Settled" class="leftEcharts"></div>
            <div ref="Settled2" class="rightEcarts"></div>
          </div>
        </el-tab-pane>
        <!-- 2报销 -->
        <el-tab-pane label="报销" name="2">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                type="date"
                @change="searchData1Change"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                @change="searchData2Change"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='2'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch1" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectFinanceClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/reimbursement_output','报销列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">报销类型</div>
                <div class="headerItem" style="width:11%;text-align:center">总金额</div>
                <div class="headerItem" style="width:13%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  :key="item.id"
                  @click="handleCheckReimbursement(item.id)"
                >
                  <div class="bodyItem" style="width:30%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p class="tableItemContent" v-if="item.type=='1'">项目实施相关费用</p>
                    <p class="tableItemContent" v-if="item.type=='2'">业务相关费用</p>
                    <p class="tableItemContent" v-if="item.type=='6'">业务拓展费</p>
                    <p class="tableItemContent" v-if="item.type=='3'">招待费</p>
                    <p class="tableItemContent" v-if="item.type=='5'">出图费</p>
                    <p class="tableItemContent" v-if="item.type=='4'">其他</p>
                  </div>
                  <div class="bodyItem" style="width:11%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p> 
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckReimbursement(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin1==0 ? false : true"
                        @click.stop="handleRemoveReimbursement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="事前报备" name="9">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                type="date"
                @change="searchData1Change"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                @change="searchData2Change"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='9'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch8" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectReportbClick"
              >新增</el-button>
              <!-- <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/reportb_output','事前报备列表')"
              >导出</el-button> -->
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">日期</div>
                <div class="headerItem" style="width:11%;text-align:center">总金额</div>
                <div class="headerItem" style="width:13%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  :key="item.id"
                  @click="handleCheckReportb(item.id)"
                >
                  <div class="bodyItem" style="width:30%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.date}}</p>
                  </div>
                  <div class="bodyItem" style="width:11%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p> 
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckReportb(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin1==0 ? false : true"
                        @click.stop="handleRemoveReportb(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 3项目结算 -->
        <el-tab-pane label="项目结算" name="3">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='3'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button class="search" @click="handleSearch2">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectClearClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/settlement_output','项目结算列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:35%">项目名称</div>
                <div class="headerItem" style="width:15%;text-align:center">申请人</div>
                <div class="headerItem" style="width:12%;text-align:center">结算金额</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.finance.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckSettlement(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:35%">
                    <!-- <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3> -->
                    <p v-if="item.type==1" style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                    <p
                      v-if="item.type==2"
                      style="color:#999;"
                      class="overflowDoit"
                    >{{item.business_name}}</p>
                  </div>

                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:12%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckSettlement(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin2==0 ? false : true"
                        @click.stop="handleRemoveSettlement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 6业务结算 -->
        <el-tab-pane label="业务结算" name="6">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='6'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button class="search" @click="handleSearch5">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addBusinessClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/business_output','业务结算列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:35%">项目名称</div>
                <div class="headerItem" style="width:15%;text-align:center">申请人</div>
                <div class="headerItem" style="width:12%;text-align:center">结算金额</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.finance.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckBusiness(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:35%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>

                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:12%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckBusiness(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin5==0 ? false : true"
                        @click.stop="handleRemoveBusiness(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 4项目专家费 -->
        <el-tab-pane label="项目专家费" name="4">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='4'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch3" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectZhuanClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/expert_output','项目专家费列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:35%">项目名称</div>
                <div class="headerItem" style="width:15%;text-align:center">申请人</div>
                <div class="headerItem" style="width:12%;text-align:center">申请金额</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click.stop="handleCheckExpert(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:35%">
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:12%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckExpert(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin3==0 ? false : true"
                        @click.stop="handleRemoveExpert(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 5到账记录 -->
        <el-tab-pane label="到账记录" name="5">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='5'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button class="search" @click="handleSearch4">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectEndClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/arrival_output','到账记录列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:35%">项目名称</div>
                <div class="headerItem" style="width:15%;text-align:center">申请人</div>
                <div class="headerItem" style="width:12%;text-align:center">申请金额</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckArrival(item.id,item)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:35%">
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:12%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckArrival(item.id,item)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin4==0 ? false : true"
                        @click.stop="handleRemoveArrival(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
       
        <!-- 8合同登记 -->
        <el-tab-pane label="合同预存" name="8">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left modifyLeft" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-input @change="searchInputTypeChange" v-model="searchType" placeholder="项目类型"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='7'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button class="search" @click="handleSearch7">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addContractClick1"
              >新增</el-button>
              <!-- <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/contract_output','合同登记列表')"
              >导出</el-button>-->
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:20%">项目名称/公司名称</div>
                <div class="headerItem" style="width:15%;text-align:center">项目类型</div>
                <div class="headerItem" style="width:15%;text-align:center">交存人</div>
                <div class="headerItem" style="width:12%;text-align:center">合同金额</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.finance.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  style="height:8vh;padding:8px 40px;"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckContract1(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:20%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                    <p style="color:#999;font-size:12px" class="overflowDoit">
                      <span style="margin-right:10px">合同编号:</span>
                      <span>{{item.ontract_no}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.project_type}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:12%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckContract1(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin6==0 ? false : true"
                        @click.stop="handleRemoveContract1(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="$store.state.process.finance.list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.finance.Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 弹窗--报销 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      key="finance"
      :before-close="handleClose"
      :class="'addFinanceDia'"
      @close="handleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="$store.state.process.finance.showForm==='2'"
          style="color:#128BF1;margin-right:5px"
        >{{editName}}-</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormAdd'&& $store.state.process.finance.formData.is_draft!='1'"
        >新增报销</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑报销</span>
        <span class="title-age" v-if="$store.state.process.finance.showForm==='showFormHandle'">报销详情</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormReportbAdd'&& $store.state.process.finance.formData.is_draft!='1'"
        >新增事前报备</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormReportbAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑新增事前报备</span>
        <span class="title-age" v-if="$store.state.process.finance.showForm==='showFormReportbHandle'">事前报备详情</span>
        <span
          class="title-age"
          v-if="($store.state.process.finance.showForm==='showFormClearAdd' || $store.state.process.finance.showForm==='showFormClearAdd1') && $store.state.process.finance.formData.is_draft!='1' "
        >新增项目结算</span>
        <span
          class="title-age"
          v-if="($store.state.process.finance.showForm==='showFormClearAdd' || $store.state.process.finance.showForm==='showFormClearAdd1') && $store.state.process.finance.formData.is_draft=='1'"
        >编辑项目结算</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormClearHandle' || $store.state.process.finance.showForm==='showFormClearHandle1'"
        >项目结算详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormZhuanAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增项目专家费</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormZhuanAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑项目专家费</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormZhuanHandle'"
        >项目专家费详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormEndAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增到账记录</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormEndAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑到账记录</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormEndHandle'"
        >到账记录详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormBusinessAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增业务结算</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormBusinessAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑业务结算</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormBusinessHandle'"
        >业务结算详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增合同登记</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑合同登记</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractHandle'"
        >合同登记详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractSaveAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增合同预存</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractSaveAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑合同预存</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractSaveHandle'"
        >合同预存详情</span>
      </div>
      <!-- <finance-details v-if="comReload" /> -->
      <finance-details />
    </el-dialog>
    <el-dialog
      :visible.sync="selectVis"
      width="40%"
      key="addType"
      class="addTypeDia addFinanceDia"
      :before-close="selectVisClose"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">选择项目类型</div>
      <div class="selectBoxSettlement">
        <div class="selectItem1" @click="addProjectClearClick1">已登记项目</div>
        <div class="selectItem2" @click="addProjectClearClick2">其他项目</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import echarts from 'echarts'
import Draggable from 'vuedraggable'
import OneSelected from '../../components/OneSelected'

import FinanceDetails from '../../components/finance/FinanceDetails'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      formData: {
        is_draft: '0',
      },
      evaluation_type_list: [],
      comReload: true,
      searchDate1: '',
      searchDate2: '',
      editName: '',
      options1: {
        title: {
          text: '收入走势（月）',
          top: '20',
          left: '30',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        legend: {
          type: 'plain',
          show: true,
          align: 'right',
          right: '2%',
          top: '2%',
          icon: 'circle',
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          show: false,
          top: '100',
        },
        xAxis: {
          type: 'category',
          // x轴
          data: [],
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            // y轴
            data: [],
            type: 'line',
            smooth: true,
            itemStyle: {
              color: 'rgb(255, 70, 131)',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(255, 158, 68, 0.2)',
                },
                {
                  offset: 1,
                  color: 'rgba(255, 70, 131, 0.01)',
                },
              ]),
            },
          },
        ],
      },
      options2: {
        title: {
          text: '支出走势（月）',
          top: '20',
          left: '30',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        grid: {
          show: false,
          top: '100',
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          // x轴
          data: [],
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
        },

        series: [
          {
            // y轴
            data: [],
            type: 'line',
            smooth: true,
            itemStyle: {
              color: '#079AEE',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(7, 154, 238, 0.2)',
                },
                {
                  offset: 1,
                  color: 'rgba(7, 154, 238, 0.01)',
                },
              ]),
            },
          },
        ],
      },
      myChart1: {},
      myChart2: {},
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      clientActive: '1',
      searchInfo1: '',
      projectTypeList: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchDate2) {
            return (
              time.getTime() > new Date(this.searchDate2).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchDate1) {
            return (
              time.getTime() <
                new Date(this.searchDate1).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      tiemID: null,
      timeDou: 100,
      financeIndexData: {},
      selectProjectNum: '',
      searchUserId: '',
      searchType: '',
    }
  },
  components: {
    Draggable,
    OneSelected,
    FinanceDetails,
  },
  methods: {
    ...mapMutations('process/finance', [
      // 搜索相关
      'assignmentSearchDateSatrt',
      'assignmentSearchDateEnd',
      'assignmentSearch_member_id',
      'assignmentSearchInfo',
      'assignmentSearchType',
      // 页码相关
      'assignmentCurrentPage',
      'assignmentPageSize',
      // 财务/行政侧边栏展示哪种table
      'getContainerType',
      'getselectVis',
    ]),

    // 点击导出(报销)
    handleOutClick(tourl, file_name) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.$store.state.process.finance.searchInfo)
      param.append(
        'search_member_id',
        this.$store.state.process.finance.search_member_id
      )
      this.$axios({
        method: 'post',
        url: tourl,
        data: param,
        // responseType: 'arraybuffer',
        // responseType: 'blob',
      }).then((res) => {
        console.log(res.data)
        if (res.data.code != 200) return this.$message.error(res.data.datas.msg)

        const fileName =
          file_name + this.parseTime(new Date(), '{y}{mm}{dd}') + '.xls'

        let link = document.createElement('a') //创建a标签
        link.style.display = 'none' //使其隐藏
        link.href = res.data.datas.file_url //赋予文件下载地址
        link.setAttribute('download', fileName) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
      })
    },

    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.assignmentSearch_member_id(data)
    },

    handleSearch1() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getReimbursementList()
    },
     handleSearch8() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getReportbList()
    },
    handleSearch2() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getSettlementList()
    },
    handleSearch3() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getExpertList()
    },
    handleSearch4() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getArrivalList()
    },
    handleSearch5() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getBusinessList()
    },
    handleSearch6() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getContractList()
    },
    handleSearch7() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getContractList1()
    },
    // 搜索栏信息改变存储到vuex
    searchData1Change(val) {
      this.assignmentSearchDateSatrt(val)
    },
    searchData2Change(val) {
      this.assignmentSearchDateEnd(val)
    },
    searchInputNameChange(val) {
      this.assignmentSearchInfo(val)
    },
    searchInputTypeChange(val) {
      this.assignmentSearchType(val)
    },
    // 搜索栏信息改变存储到vuex

    // *8获取合同预存
    async getContractList1() {
      this.$store.commit('process/finance/getContractList1')
      console.log('合同登记列表', this.$store.state.process.finance.list)
    },
    // *8查看合同预存详情
    async handleCheckContract1(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Financer/contract_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormContractSaveAdd'
        )
      } else {
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormContractSaveHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *8合同预存删除
    async handleRemoveContract1(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Financer/contract_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getContractList1()
      }
    },

    // *7获取合同登记
    async getContractList() {
      this.$store.commit('process/finance/getContractList')
      console.log('合同登记列表', this.$store.state.process.finance.list)
    },
    // *7查看合同登记详情
    async handleCheckContract(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/contract_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract')
        this.$store.commit('process/finance/getShowForm', 'showFormContractAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract')
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormContractHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *7合同登记删除
    async handleRemoveContract(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/contract_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getContractList()
      }
    },

    // *6获取业务结算申请列表
    async getBusinessList() {
      this.$store.commit('process/finance/getBusinessList')
      console.log('业务结算申请列表', this.$store.state.process.finance.list)
    },
    // *6查看业务结算申请详情
    async handleCheckBusiness(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/business_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      let arrProject = this.formData.project_list.map((item) => {
        return item.project_id
      })
      this.formData.project_id = [...arrProject]
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('business')
        this.$store.commit('process/finance/getShowForm', 'showFormBusinessAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('business')
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormBusinessHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *6业务结算申请删除
    async handleRemoveBusiness(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/business_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getBusinessList()
      }
    },

    // *查看到账记录详情
    async handleCheckArrival(id,item) {
     console.log('查看到账记录详情')
     this.projectSearchById(item.project_list[0].project_id)
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/arrival_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
     console.log('到账记录详情',this.formData)
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('arrival')
        this.$store.commit('process/finance/getShowForm', 'showFormEndAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('arrival')
        this.$store.commit('process/finance/getShowForm', 'showFormEndHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *到账记录删除
    async handleRemoveArrival(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/arrival_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getArrivalList()
      }
    },
    // *获取到账记录列表
    async getArrivalList() {
      this.$store.commit('process/finance/getArrivalList')
      console.log('到账记录列表', this.$store.state.process.finance.list)
    },

    // *查看项目专家费申请详情
    async handleCheckExpert(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/expert_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('expert')
        this.$store.commit('process/finance/getShowForm', 'showFormZhuanAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('expert')
        this.$store.commit('process/finance/getShowForm', 'showFormZhuanHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *项目专家费申请删除
    async handleRemoveExpert(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/expert_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getExpertList()
      }
    },
    // *获取项目专家费申请列表
    async getExpertList() {
      this.$store.commit('process/finance/getExpertList')
      console.log('项目专家费申请列表', this.$store.state.process.finance.list)
    },

    // *查看项目结算申请详情
    async handleCheckSettlement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/settlement_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理json
      if (this.formData.money_json) {
        this.formData.money_json = JSON.parse(this.formData.money_json)
        // 处理移动端修改没有id
        this.formData.money_json.forEach((item) => {
          if (!item.id)
            item.id = parseInt((Math.random() + 1) * Math.pow(10, 6 - 1))
        })
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('settlement')
        if (res.datas.info.type == '1') {
          this.$store.commit('process/finance/getShowForm', 'showFormClearAdd')
        }
        if (res.datas.info.type == '2') {
          this.$store.commit('process/finance/getShowForm', 'showFormClearAdd1')
        }
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('settlement')

        if (res.datas.info.type == '1') {
          this.$store.commit(
            'process/finance/getShowForm',
            'showFormClearHandle'
          )
        }
        if (res.datas.info.type == '2') {
          this.$store.commit(
            'process/finance/getShowForm',
            'showFormClearHandle1'
          )
        }
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *项目结算申请删除
    async handleRemoveSettlement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/settlement_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getSettlementList()
      }
    },
    // *获取项目结算申请列表
    async getSettlementList() {
      this.$store.commit('process/finance/getSettlementList')
      console.log('项目结算申请列表', this.$store.state.process.finance.list)
    },
  // *查看事前报备详情
    async handleCheckReportb(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/reportb_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('reportb')
        this.$store.commit('process/finance/getShowForm', 'showFormReportbAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('reportb')
        this.$store.commit('process/finance/getShowForm', 'showFormReportbHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *报销事前报备删除
    async handleRemoveReportb(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reportb_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReportbList()
      }
    },
    // *获取事前报备申请列表
    async getReportbList() {
      this.$store.commit('process/finance/getReportbList')
      console.log('事前报备申请列表', this.$store.state.process.finance.list)
    },
    // *查看报销详情
    async handleCheckReimbursement(id) {
      
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/reimbursement_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('reimbursement')
        this.$store.commit('process/finance/getShowForm', 'showFormAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('reimbursement')
        this.$store.commit('process/finance/getShowForm', 'showFormHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *报销删除
    async handleRemoveReimbursement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reimbursement_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReimbursementList()
      }
    },

     // 按搜索条件查找，不在本地进行查找
 async projectSearchById(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
     
      param.append('project_id', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('BYID获取项目列表', this.$store.state.process.finance.projectList)
     
   },


    // 获取项目列表，只有点击报销时传递type=1返回全部项目
    async projectSearch(){
  
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      param.append('type', '1')
     
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },
   // 获取项目列表，只有点击报销时传递type=1返回全部项目
   async projectSearch2(){
  
  let param = new FormData()
    param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
    param.append('token', localStorage.getItem('btlh_process_token') || '')
    
    param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
    param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
   
    
    const { data: res } = await this.$axios({
      method: 'post',
      url: '/api/Project/simple_project',
      data: param,
    })
    if (res.code != 200) return this.$message.error(res.datas.msg)
    console.log(res.datas.listInfo)
    this.$store.commit(
      'process/finance/assignmentProject',
      res.datas.listInfo
    )
    if (res.datas.listInfo.length > this.moreNum) {
      this.$store.commit(
        'process/finance/setprojectListSub',
        res.datas.listInfo.slice(0, this.moreNum)
      )
    } else {
      this.$store.commit(
        'process/finance/setprojectListSub',
        res.datas.listInfo
      )
    }
    console.log('获取项目列表', this.$store.state.process.finance.projectList)
   
 },


    // *获取报销列表
    async getReimbursementList() {
     
      this.$store.commit('process/finance/getReimbursementList')
    },
    handleSearchIndex() {
      this.getFinanceIndex()
    },
    // *获取财务总览
    async getFinanceIndex() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('date_start', this.searchDate1)
      param.append('date_end', this.searchDate2)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/index',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.financeIndexData = res.datas
      console.log('财务总览', this.financeIndexData)
      const arrdate = this.financeIndexData.list.map((item) => {
        return item.date
      })
      const income = this.financeIndexData.list.map((item) => {
        return item.income
      })
      const expenses = this.financeIndexData.list.map((item) => {
        return item.expenses
      })

      this.options1.xAxis.data = arrdate
      this.options2.xAxis.data = arrdate
      this.options1.series[0].data = income
      this.options2.series[0].data = expenses
      // const arr29 = []
      // for (let index = 0; index < 29; index++) {
      //   arr29.push(50)
      // }
      // this.options1.series[0].data = arr29
      // this.options2.series[0].data = arr29
      console.log('this.options1', this.options1)
      console.log('this.options2', this.options2)
      this.$nextTick(() => {
        this.SettledLine1()
        this.SettledLine2()
      })
    },

    // *获取项目列表
    async getProjectList() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
    },
    // *获取项目列表(异步)
    getProjectListAsync(addClick, getList) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      }).then((res1) => {
        if (res1.data.code != 200) {
          getList()
          return this.$message.error(res1.data.datas.msg)
        }
        this.$store.commit(
          'process/finance/assignmentProject',
          res1.data.datas.listInfo
        )
        if (res1.data.datas.listInfo.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectListSub',
            res1.data.datas.listInfo.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectListSub',
            res1.data.datas.listInfo
          )
        }
        getList()
        setTimeout(() => {
          addClick()
        })
      })
    },
    // *获取项目列表1(异步项目结算and业务结算)
    getProjectList1Async(addClick, getList) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      this.$axios({
        method: 'post',
        url: '/api/Project/fsimple_project',
        data: param,
      }).then((res1) => {
        if (res1.data.code != 200) {
          getList()
          return this.$message.error(res1.data.datas.msg)
        }
        this.$store.commit(
          'process/finance/assignmentProject1',
          res1.data.datas.listInfo
        )
        if (res1.data.datas.listInfo.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectList1Sub',
            res1.data.datas.listInfo.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectList1Sub',
            res1.data.datas.listInfo
          )
        }
        getList()
        setTimeout(() => {
          addClick()
        })
      })
    },
    // *获取项目列表(项目结算and业务结算)
    async getProjectList1() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/fsimple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit(
        'process/finance/assignmentProject1',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectList1Sub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectList1Sub',
          res.datas.listInfo
        )
      }
      console.log(
        '^&*(获取项目列表(项目结算and业务结算)',
        this.$store.state.process.finance.projectList1
      )
    },
    // 获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型列表', this.projectTypeList)
    },
    // 获取评价类型
    async getPjList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/evaluation_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.evaluation_type_list = res.datas.listInfo
      console.log('评价类型列表', this.projectTypeList)
    },

    SettledLine1() {
      let Settled = this.$echarts.init(this.$refs.Settled)
      this.myChart1 = Settled
      // 绘制已结算图表
      Settled.setOption(this.options1)
    },
    SettledLine2() {
      let Settled = this.$echarts.init(this.$refs.Settled2)
      this.myChart2 = Settled
      // 绘制已结算图表
      Settled.setOption(this.options2)
    },

    // ***获取预设审批人
    async get_preset_by_stage_code(stage_code) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/get_preset_by_stage_code',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit('process/finance/setList3', res.datas.list)
    },

    // 8.点击新增合同预存
    addContractClick1() {
      const data = {
        preset_member: '',

        project_type: '',
        pay_type: '',
        is_review: '1',
        pay_review_type: '1',

        is_reg: '0',
        is_bid: '0',
        bid_money: 0,
        is_mark: '0',
        mark_json: '0',
        ontract_no: '',
        business_name: '',
        project_type: '',
        manager: '',
        paid: '',
        date_sign: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProject == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      // this.get_preset_by_stage_code('contract')
      this.$store.commit(
        'process/finance/getShowForm',
        'showFormContractSaveAdd'
      )
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },

    // 7.点击新增合同登记
    addContractClick() {
      const data = {
        preset_member: '',

        pay_type: '',
        is_review: '1',
        pay_review_type: '1',

        is_reg: '0',
        is_bid: '0',
        bid_money: 0,
        is_mark: '0',
        mark_json: '0',
        ontract_no: '',
        business_name: '',
        project_type: '',
        manager: '',
        paid: '',
        date_sign: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProject == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('contract')
      this.$store.commit('process/finance/getShowForm', 'showFormContractAdd')
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 6.点击新增业务结算申请
    addBusinessClick() {
      const data = {
        preset_member: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('business')
      this.$store.commit('process/finance/getShowForm', 'showFormBusinessAdd')
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 点击新增到账记录
    addProjectEndClick() {
      const data = {
        preset_member: '',

        is_settle: '0',
        is_settlement: '0',
        project_list: [],
        total: '',
        date: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('arrival')
      this.$store.commit('process/finance/getShowForm', 'showFormEndAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 点击新增专家申请费
    addProjectZhuanClick() {
      const data = {
        preset_member: '',

        type: '',
        total: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('expert')
      this.$store.commit('process/finance/getShowForm', 'showFormZhuanAdd')
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },
    //  *(修改)点击新增项目结算选择选择新增的项目结算类型
    addProjectClearClick() {
      this.getselectVis(true)
    },
    selectVisClose() {
      this.getselectVis(false)
    },
    // 点击新增项目结算申请按钮(已登记项目)
    addProjectClearClick1() {
      const data = {
        preset_member: '',

        money: 0,
        is_handle: '0',
        is_special: '0',
        special_money: 0,
        money_json: [],
        project_list: [],
        total: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('settlement')
      this.$store.commit('process/finance/getShowForm', 'showFormClearAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 点击新增项目结算申请按钮(其他项目)
    addProjectClearClick2() {
      const data = {
        preset_member: '',

        type: 0,
        business_name: '',
        total: 0,

        remark: '',
        annex: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('settlement')
      this.$store.commit('process/finance/getShowForm', 'showFormClearAdd1')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
       // 点击新增事前报备按钮
    addProjectReportbClick() {
      const data = {
        preset_member: '',

        is_draft: '0',
        type: '1',
        title: '',
        destination: '',
        date: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: [],
        project_id: [],
        bill: '',
        no_bill: '',
      }

      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('reportb')
      this.$store.commit('process/finance/getShowForm', 'showFormReportbAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 点击新增报销按钮
    addProjectFinanceClick() {
      const data = {
        preset_member: '',

        is_draft: '0',
        type: '1',
        title: '',
        destination: '',
        date: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: [],
        project_id: [],
        bill: '',
        no_bill: '',
      }

      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('reimbursement')
      this.$store.commit('process/finance/getShowForm', 'showFormAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    handleClick(tab, event) {
     console.log('tab.name',tab.name)
      // isFromProject==2是弹窗关闭后  this$route.query.isFromProject=2  了
      if (
        this.$route.query.isFromProject == '1' ||
        this.$route.query.isFromProject == '2'
      ) {
        this.$router.push({ query: {} })
      }
      // isFromProjectDrawer==2是弹窗关闭后  this$route.query.isFromProjectDrawer=2  了
      if (
        this.$route.query.isFromProjectDrawer == '1' ||
        this.$route.query.isFromProjectDrawer == '2'
      ) {
        this.$router.push({ query: {} })
      }
      this.searchInfo1 = ''
      this.assignmentSearchInfo('')
      this.searchDate1 = ''
      this.assignmentSearchDateSatrt('')
      this.searchDate2 = ''
      this.assignmentSearchDateEnd('')
      this.searchType = ''
      this.assignmentSearchType('')
      this.searchUserId = ''
      this.assignmentSearch_member_id('')

      this.assignmentPageSize(10)
      this.assignmentCurrentPage(1)
      // console.log(tab, event)
      if (tab.name == '1') {
        this.getFinanceIndex()
      } else if (tab.name == '2') {

        this.getReimbursementList()
        this.projectSearch()
      } else if (tab.name == '3') {
        this.getSettlementList()
      } else if (tab.name == '4') {
        this.getExpertList()
        this.projectSearch2()
      } else if (tab.name == '5') {
        this.getArrivalList()
        this.projectSearch2()
      } else if (tab.name == '6') {
        this.getBusinessList()
        
      } else if (tab.name == '7') {
        this.getContractList()
        this.projectSearch2()
      } else if (tab.name == '8') {
        this.getContractList1()
        this.projectSearch2()
      }else if (tab.name == '9') {

        this.getReportbList()
        this.projectSearch()
      }
      
    },
    handleClose(done) {
      this.$store.commit('process/finance/getDialogVisible', false)
    },
    handleClosed() {
      // 清空项目传来的id
      this.$route.query.isFromProject = 2
      this.$route.query.isFromProjectDrawer = 2
      // 清空预设审批人
      this.$store.commit('process/finance/setList3', [])

      this.$store.commit('process/finance/emptyFormData')
      this.$store.commit('process/finance/getDraftDisable', false)
      this.$store.commit('process/finance/getSideBarShow', false)
      this.getContainerType('0')
      this.comReload = false
      setTimeout(() => {
        this.comReload = true
      }, 1)
    },
    handleSizeChange(val) {
      this.assignmentPageSize(val)
      if (this.clientActive == 2) {
        this.getReimbursementList()
      }
      if (this.clientActive == 3) {
        this.getSettlementList()
      }
      if (this.clientActive == 4) {
        this.getExpertList()
      }
      if (this.clientActive == 5) {
        this.getArrivalList()
      }
      if (this.clientActive == 6) {
        this.getBusinessList()
      }
      if (this.clientActive == 7) {
        this.getContractList()
      }
      if (this.clientActive == 8) {
        this.getContractList1()
      }
      if (this.clientActive == 9) {
        this.getReportbList()
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.assignmentCurrentPage(val)
      if (this.clientActive == 2) {
        this.getReimbursementList()
      }
      if (this.clientActive == 3) {
        this.getSettlementList()
      }
      if (this.clientActive == 4) {
        this.getExpertList()
      }
      if (this.clientActive == 5) {
        this.getArrivalList()
      }
      if (this.clientActive == 6) {
        this.getBusinessList()
      }
      if (this.clientActive == 7) {
        this.getContractList()
      }
      if (this.clientActive == 8) {
        this.getContractList1()
      }
      if (this.clientActive == 9) {
        this.getReportbList()
      }
    },
    // 解析时间
    parseTime(time, fm) {
      // 解析时间  time: 时间戳或者实践对象 fm: 格式 默认是{y}-{m}-{d} {h}:{i}:{s}
      if (arguments.length === 0) {
        return null
      }
      const format = fm || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a')
          return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
  },
  watch: {
    clientActive(val, oldVal) {
      //普通的watch监听
      switch (val) {
        case '3':
        case '6':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        case '4':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '60px'
          })
          break
        case '5':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break

        case '7':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        case '8':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        default:
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '30px'
          })
          break
      }
    },
  },
  activated() {
    // !项目带id跳转合同登记
    if (this.$route.query.isFromProject == '1') {
      this.clientActive = '7'
      this.getProjectListAsync(this.getContractList, this.addContractClick)
    }
    // !项目带id跳转别的
    if (this.$route.query.isFromProjectDrawer == '1') {
      switch (this.$route.query.fromDrawType) {
        case '报销':
          this.clientActive = '2'
          this.getProjectListAsync(
            this.getReimbursementList,
            this.addProjectFinanceClick
          )
          break
        case '事前报备':
          this.clientActive = '9'
          this.getProjectListAsync(
            this.getReportbList,
            this.addProjectReportbClick
          )
          break
        case '业务结算':
          this.clientActive = '6'
          this.getProjectList1Async(this.getBusinessList, this.addBusinessClick)
          break
        case '项目专家费':
          this.clientActive = '4'
          this.getProjectListAsync(
            this.getExpertList,
            this.addProjectZhuanClick
          )
          break
        case '到账记录':
          this.clientActive = '5'
          this.getProjectListAsync(this.getArrivalList, this.addProjectEndClick)
          break
        case '项目结算':
          this.clientActive = '3'
          this.getProjectList1Async(
            this.getSettlementList,
            this.addProjectClearClick
          )
          break
        case '合同登记':
          this.clientActive = '7'
          this.getProjectListAsync(this.getContractList, this.addContractClick)
          break
        default:
          break
      }
    }
  },
  async created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getPjList()
    this.getProjectList1()
    this.getProjectList()
    this.getProjectTypeList()
    this.getFinanceIndex()
  },
  mounted() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.myChart1.resize()
        this.myChart2.resize()
      })
    }
  },
  computed: {
    ...mapState('process/finance', [
      // 搜索相关
      'searchDateSatrt',
      'searchDateEnd',
      'search_member_id',
      'searchInfo',
      // 页码相关
      'currentPage',
      'pageSize',
      // 详情弹窗可见
      'dialogVisible',
      'moreNum',
      'selectVis',
    ]),
  },
}
</script>
<style lang="less" scoped>
@import url(./finance.scss);
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;

    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
</style>
